exports = module.exports = require("../../../css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._29jY-DDBWNxBYSiiV0Qhe8{width:50%}", ""]);
// Exports
exports.locals = {
	"column": "_29jY-DDBWNxBYSiiV0Qhe8"
};